/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeTable } from '@mairistem/liste';

import { EllipsisText } from '@/components/Common';

import {
  formatDateHeureListe,
  formatDateSeule,
  formatNumeroActeListe,
} from '@/utils';

interface ActeDecesListeTableRowProps {
  item: any;
  selected?: boolean;
  /** Réduit la ligne à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeDecesListeTableRow = (props: ActeDecesListeTableRowProps) => {
  const { item, selected, sidebar } = props;

  if (!item) return null;

  const annee = item?.annee;
  const numeroRegistre = item?.numero_registre;
  const libelleRegistre = item?.libelle_registre;
  const libelleTypeActe = item?.libelle_type_acte;
  const dateActe = item?.date_acte;
  const heureActe = item?.heure_acte;
  const minuteActe = item?.minute_acte;
  const nomClassementDefunt = item?.nom_classement;
  const nomClassementPere = item?.nom_classement_pere;
  const nomClassementMere = item?.nom_classement_mere;
  const dateDeces = item?.date_deces;

  const registre =
    annee || numeroRegistre || libelleRegistre
      ? `${annee ?? '-'} - ${numeroRegistre ?? '-'} - ${
          libelleRegistre ? libelleRegistre.toUpperCase() : '-'
        }`
      : '-';

  const acte = formatNumeroActeListe(item);

  const dresse = formatDateHeureListe(dateActe, heureActe, minuteActe);

  if (sidebar) {
    return (
      <ListeTable.Row key={item.identifiant ?? item?.id} selected={selected}>
        <ListeTable.Cell name="nom">
          <EllipsisText text={nomClassementDefunt || 'Non renseigné'} />
        </ListeTable.Cell>
      </ListeTable.Row>
    );
  }

  return (
    <ListeTable.Row key={item.identifiant ?? item?.id} selected={selected}>
      <ListeTable.Cell name="registre">
        <EllipsisText text={registre} />
      </ListeTable.Cell>
      <ListeTable.Cell name="typeActe">
        <EllipsisText text={libelleTypeActe || '-'} />
      </ListeTable.Cell>
      <ListeTable.Cell name="numero">
        <EllipsisText text={acte} />
      </ListeTable.Cell>
      <ListeTable.Cell name="dresse">
        <EllipsisText text={dresse} />
      </ListeTable.Cell>
      <ListeTable.Cell name="dateDeces">
        {/* Une date SEULE : `ad_dc_heure` n'alimente pas cette colonne, l'heure
            du décès n'apparaît que sur la fiche. */}
        <EllipsisText text={formatDateSeule(dateDeces) || '-'} />
      </ListeTable.Cell>
      <ListeTable.Cell name="defunt">
        <EllipsisText text={nomClassementDefunt || 'Non renseigné'} />
      </ListeTable.Cell>
      <ListeTable.Cell name="parent1">
        <EllipsisText text={nomClassementPere || 'Non renseigné'} />
      </ListeTable.Cell>
      <ListeTable.Cell name="parent2">
        <EllipsisText text={nomClassementMere || 'Non renseigné'} />
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default ActeDecesListeTableRow;
